import Keycloak from 'keycloak-js';
 
let keycloakInstance = null;
let keycloakInitPromise = null;
 
export const getKeycloakConfig = () => ({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});
 
export const hasKeycloakConfig = () => {
  const cfg = getKeycloakConfig();
  return Boolean(cfg.url && cfg.realm && cfg.clientId);
};
 
export const getKeycloak = () => {
  if (!hasKeycloakConfig()) return null;
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak(getKeycloakConfig());
  }
  return keycloakInstance;
};
 
export const resetKeycloak = () => {
  keycloakInstance = null;
};

export const initializeKeycloak = (initoptions) => {
  const keycloak = getKeycloak();
  if (!keycloak) {
    return Promise.resolve(false);
  }
  if (!keycloakInitPromise) {
    keycloakInitPromise = keycloak.init(initoptions).catch((error) => {
      keycloakInitPromise = null;
      throw error;
    });
  }
  return keycloakInitPromise;
};

export const resetkeycloak = () => {
  keycloakInstance = null;
  keycloakInitPromise = null;
};